module.exports = __webpack_public_path__ + "img/hand@2x.8ccd539c.png";